import { SingleResource } from 'services/ContentfulService/models/resource/resource'
import { RichText } from 'components/vendor/Contentful/richText/RichTextRenderer'

interface Props {
	resource: SingleResource
}

export const ResourceRenderer: React.FC<React.PropsWithChildren<Props>> = ({ resource }) => {
	if (resource.richTextValue) return <RichText document={resource.richTextValue} />
	return null
}
